import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useWindowSize } from 'react-use'
import { getCountryInfo } from '../store/actions/apiActions'
import gameActions from '../store/actions/gameActions'
import narrativesObject from '../narratives/narrativesObject'
import mapImg from "../assets/img/others/map.png"
import AnimationLayout from '../components/AnimationLayout'
import MatildeBalloon from '../components/MatildeBalloon'

const Travel = () => {
    const dispatch = useDispatch()
    const level = useSelector(state => state.firebase.profile.level)
    const { width } = useWindowSize();
    const unlockedCountries = []

    const getUnlockedValue = (item, requiredLvl) => {
        if (level < requiredLvl) {
            return false;
        } else {
            return true;
        }
    }

    for (let item of narrativesObject) {
        let check = getUnlockedValue(item.country, item.lvl)
        check && unlockedCountries.push(item.country)
    }

    return (
        <AnimationLayout>
            <h1 className='w-full'>Viajar</h1>

            <MatildeBalloon>
                <p className='text-left pb-2'>
                    Tantos países que gostaria de visitar! Todavia tenho de ter cuidado e ir ganhando mais experiência<span className='orange-highlight'>*</span> para me sentir segura em certos países.
                    Por agora sinto-me segura para visitar os seguintes países:
                    </p>

                {unlockedCountries.map((item, index) =>
                    <p className='font-bold' key={index}>{item}</p>
                )}

                <p className='pt-4 text-sm'><span className='orange-highlight'>*</span>Se não percebeu o conceito de experiência ou de nível visite a opção de ajuda que se encontra no menu.</p>

            </MatildeBalloon>
            {width >= 1024 ?
                <div id='travelPage' className='flex justify-center items-center w-full'>
                    <div className='travel-map static mx-auto' style={{
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${mapImg})`,
                        backgroundRepeat: `no-repeat`,
                        backgroundSize: `contain`,
                        backgroundPosition: `center`,
                    }}>

                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2093 1174">
                            {narrativesObject.map((item, index) => {
                                let isCountryUnlocked = getUnlockedValue(item.country, item.lvl)

                                return (
                                    <>
                                        {isCountryUnlocked ?
                                            (item.country === 'Sri Lanka') ?
                                                <g>
                                                    <Link
                                                        className='element'
                                                        to={`/viajar/${item.link}`}
                                                        onClick={() => {
                                                            dispatch(getCountryInfo(item.code, item.country))
                                                            dispatch(gameActions.getNarrativeObject(item))
                                                        }}
                                                    >
                                                        <path className={`${isCountryUnlocked ? "unlocked" : "locked"}`} d={item.path} />
                                                        <g class="st6">
                                                            <g>
                                                                <path d={item.locationMarker} />
                                                                <path d={item.locationMarker2} />
                                                            </g>
                                                            <text transform={item.transform} class="st3 st4 st8">{item.country}</text>
                                                        </g>

                                                    </Link>
                                                </g>
                                                :
                                                <g>
                                                    <Link
                                                        className='element'
                                                        to={`/viajar/${item.link}`}
                                                        onClick={() => {
                                                            dispatch(getCountryInfo(item.code, item.country))
                                                            dispatch(gameActions.getNarrativeObject(item))
                                                        }}
                                                    >
                                                        <path className={`${isCountryUnlocked ? "unlocked" : "locked"}`} d={item.path} />
                                                        <g class="st6">
                                                            <g>
                                                                <path d={item.locationMarker} />
                                                                <path d={item.locationMarker2} />
                                                            </g>
                                                            <text transform={item.transform} class={item.country === 'Sri Lanka' ? "st3 st4 st8" : "st3 st4 st5"}>{item.country}</text>
                                                        </g>

                                                    </Link>
                                                </g>
                                            :
                                            <g>
                                                <path className={`${isCountryUnlocked ? "unlocked" : "locked"}`} d={item.path} />
                                                <g>
                                                    <g>
                                                        <path class="st2" d={item.locationMarker} />
                                                        <path class="st2" d={item.locationMarker2} />
                                                    </g>
                                                    <text transform={item.transform} class="st3 st4 st5">{item.country}</text>
                                                </g>
                                            </g>
                                        }
                                    </>
                                )
                            })}
                        </svg>
                    </div>
                </div>
                :
                <div className='grid grid-cols-1 gap-4 mb-10'>
                    {narrativesObject.map((item, index) => {
                        let isCountryUnlocked = getUnlockedValue(item.country, item.lvl)

                        return (
                            <>
                                {isCountryUnlocked ?
                                    <section id='unlockedCountrys'>
                                        <Link
                                            key={index}
                                            to={`/viajar/${item.link}`}
                                            onClick={() => {
                                                dispatch(getCountryInfo(item.code, item.country))
                                                dispatch(gameActions.getNarrativeObject(item))
                                            }}
                                        >
                                            <div
                                                className={`image-button flex flex-col justify-start text-left pt-4 p-8 mb-8 ${!isCountryUnlocked ? `disabled` : `usable`}`}
                                                style={{
                                                    backgroundImage: `linear-gradient(to left, transparent, #e4e4e4 50%), url(${require(`../assets/img/${item.image}`)})`,
                                                    backgroundSize: "cover",
                                                    backgroundPosition: "center"
                                                }}
                                            >
                                                <h2 className='p-0'>{item.country}</h2>
                                                <p>{!isCountryUnlocked ? 'País bloqueado*' : 'País desbloqueado'}</p>
                                                {!isCountryUnlocked && <p className='text-sm'>* Necessita de atingir o nível {item.lvl}</p>}
                                            </div>
                                        </Link>
                                    </section>
                                    :
                                    <section id='lockedCountrys'>
                                        <div
                                            className={`image-button flex flex-col justify-start text-left pt-4 p-8 mb-8 ${!isCountryUnlocked ? `disabled` : `usable`}`}
                                            style={{
                                                backgroundImage: `linear-gradient(to left, transparent, #e4e4e4 50%), url(${require(`../assets/img/${item.image}`)})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center"
                                            }}
                                        >
                                            <h2 className='p-0'>{item.country}</h2>
                                            <p>{!isCountryUnlocked ? 'País bloqueado*' : 'País desbloqueado'}</p>
                                            {!isCountryUnlocked && <p className='text-sm'>* Necessita de atingir o nível {item.lvl}</p>}
                                        </div>
                                    </section>
                                }
                            </>
                        )
                    })}
                </div>
            }
        </AnimationLayout >
    )
}

export default Travel